import React from 'react';
import LocalizedMessage from 'react-l10n';

function CartModalEmpty(props) {
    return (
        <div className='boxed-message' id='cart-empty'>
            <div className='boxed-message__header'>
                <div className='text-box text-box--center'>
                    <p>
                        <LocalizedMessage id={'CART_NO_ITEMS'} />
                    </p>
                </div>
            </div>
        </div>
    );
}

export default CartModalEmpty;
